import { render, staticRenderFns } from "./Report_adult.vue?vue&type=template&id=3ac50418&scoped=true&"
import script from "./Report_adult.vue?vue&type=script&lang=js&"
export * from "./Report_adult.vue?vue&type=script&lang=js&"
import style0 from "./Report_adult.vue?vue&type=style&index=0&id=3ac50418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac50418",
  null
  
)

export default component.exports